import React from 'react';

import { type DetailedValidationError, TableCell, TableRow } from '@ifs-gcp/components';

import { getTranslation } from '@/utils/translations';

export interface ErrorRowProps {
  language: string;
  errorIndex: number;
  error: DetailedValidationError;
  redirectHandler: (errorId: string, paths: DetailedValidationError['paths']) => void;
}

export const GenericErrorRow = ({
  language,
  errorIndex,
  redirectHandler,
  error: { id, fieldId, label, error, type, paths },
}: ErrorRowProps) => {
  const findRowSibling = (element: HTMLElement, key: string): HTMLTableRowElement | null => {
    const sibling =
      key === 'ArrowUp' ? element?.previousElementSibling : element?.nextElementSibling;

    if (!sibling || !(sibling instanceof HTMLTableRowElement)) {
      return null;
    }

    if (sibling instanceof HTMLTableRowElement && !sibling.hasAttribute('data-focusable')) {
      return findRowSibling(sibling, key);
    }

    if (sibling.hasAttribute('data-focusable')) {
      return sibling;
    }

    return findRowSibling(sibling, key);
  };

  const handleKeyDown = (event: KeyboardEvent | React.KeyboardEvent<HTMLTableRowElement>) => {
    event.preventDefault();
    event.stopPropagation();

    const foundSibling = findRowSibling(event.target as HTMLElement, event.key);

    if (foundSibling) {
      foundSibling.focus();
    }
  };

  return (
    <TableRow
      hover
      data-focusable
      tabIndex={errorIndex}
      onClick={() => redirectHandler(id ?? fieldId, paths)}
      onKeyDown={(event) => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          handleKeyDown(event);
        } else if (event.key === 'Enter') {
          redirectHandler(id ?? fieldId, paths);
        }
      }}
    >
      <TableCell>{type}</TableCell>
      <TableCell>{getTranslation(label, language)}</TableCell>
      <TableCell>{getTranslation(error, language)}</TableCell>
    </TableRow>
  );
};
